import React from 'react';
import { getBackendUrl } from '../lib/backend';

const Landing: React.FC = () => {
  const handleLogin = () => {
    window.location.href = `${getBackendUrl()}/auth/google`;
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-background flex items-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <h1 className="text-4xl tracking-tight font-extrabold text-primary sm:text-5xl md:text-6xl">
            <span className="block">Tu Asistente IA Personal</span>
            <span className="block text-secondary">Gestión Inteligente de Calendario</span>
          </h1>
          <p className="mt-3 max-w-md mx-auto text-base text-gray-600 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            Optimiza tu agenda con gestión de calendario potenciada por IA. Obtén asistencia
            personalizada para programar reuniones, administrar tu tiempo y mantenerte organizado.
          </p>
          <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
            <div className="rounded-md shadow">
              <button
                onClick={handleLogin}
                className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary/90 md:py-4 md:text-lg md:px-10"
              >
                Iniciar con Google
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
